import orderBy from 'lodash.orderby';

import API from '@/api';

export function isMenuCategoryAddedToTVDecoder(menuCategory, tvdecoder) {
  return tvdecoder.allowed_menu_categories
    .map((category) => category.id)
    .includes(menuCategory.id);
}

export function maybeGetMenuCategoryWithTVDecoderContext(
  menuCategory,
  tvdecoder
) {
  const categoryWithContext = tvdecoder.allowed_menu_categories.filter(
    (category) => category.id == menuCategory.id
  )[0];
  return categoryWithContext || menuCategory;
}

export function setMenuCategoryContentModeOnTVDecoder(
  menuCategory,
  tvdecoder,
  contentMode,
  callback = null
) {
  // Frontend update.
  const menuCategoryWithTVDecoderContext =
    tvdecoder.allowed_menu_categories.filter(
      (category) => category.id == menuCategory.id
    )[0];
  if (menuCategoryWithTVDecoderContext) {
    menuCategoryWithTVDecoderContext.content_mode = contentMode;
  } else {
    tvdecoder.allowed_menu_categories.push({
      ...menuCategory,
      content_mode: contentMode,
    });
    tvdecoder.allowed_menu_categories = orderBy(
      tvdecoder.allowed_menu_categories,
      ['order', 'name']
    );
  }

  // Backend update.
  API.setMenuCategoryContentModeOnTVDecoder(
    menuCategory,
    tvdecoder,
    contentMode
  ).then(() => {
    if (callback) {
      callback();
    }
  });
}

export function addMenuCategoryToTVDecoder(
  menuCategory,
  tvdecoder,
  callback = null
) {
  if (isMenuCategoryAddedToTVDecoder(menuCategory, tvdecoder)) {
    return;
  }

  // Frontend update.
  tvdecoder.allowed_menu_categories.push({
    ...menuCategory,
    content_mode: 'ALL',
  });
  tvdecoder.allowed_menu_categories = orderBy(
    tvdecoder.allowed_menu_categories,
    ['order', 'name']
  );

  // Backend update.
  API.addMenuCategoryToTVDecoder(menuCategory, tvdecoder).then(() => {
    if (callback) {
      callback();
    }
  });
}

export function removeMenuCategoryFromTVDecoder(
  menuCategory,
  tvdecoder,
  callback = null
) {
  const index = tvdecoder.allowed_menu_categories.findIndex(
    (category) => category.id === menuCategory.id
  );
  if (index < 0) {
    return;
  }

  // Frontend update.
  tvdecoder.allowed_menu_categories.splice(index, 1);
  tvdecoder.allowed_menu_categories = orderBy(
    tvdecoder.allowed_menu_categories,
    ['order', 'name']
  );

  // Backend update.
  API.removeMenuCategoryFromTVDecoder(menuCategory, tvdecoder).then(() => {
    if (callback) {
      callback();
    }
  });
}



// WEBPACK FOOTER //
// ./src/mixins/allowedMenuCategories.js